export default __webpack_public_path__ + "static/media/load.0c3992c0.svg";